module.exports = __webpack_public_path__ + "img/settings-icon.6b99f848.svg";